export const HOBBY_LABELS = {
  pickleball: { en: "Pickleball", zh: "匹克球" },
  golf: { en: "Golf", zh: "高尔夫" },
  cigars: { en: "Cigars", zh: "雪茄" },
  wine: { en: "Wine", zh: "红酒" },
  yoga: { en: "Yoga", zh: "瑜伽" },
  tennis: { en: "Tennis", zh: "网球" },
  sailing: { en: "Sailing", zh: "帆船" },
  watches: { en: "Watches", zh: "腕表" },
  fine_dining: { en: "Fine Dining", zh: "美食" },
  art: { en: "Art", zh: "艺术" },
  equestrian: { en: "Equestrian", zh: "马术" },
  skiing: { en: "Skiing", zh: "滑雪" },
  hiking: { en: "Hiking", zh: "徒步" },
  photography: { en: "Photography", zh: "摄影" },
  jazz: { en: "Jazz", zh: "爵士" },
  classical_music: { en: "Classical", zh: "古典乐" },
  f1: { en: "F1", zh: "F1" },
  theater: { en: "Theater", zh: "剧场" },
  whisky: { en: "Whisky", zh: "威士忌" },
  cycling: { en: "Cycling", zh: "骑行" },
};

export const labelHobby = (key) =>
  HOBBY_LABELS[key] ? `${HOBBY_LABELS[key].zh} · ${HOBBY_LABELS[key].en}` : key;
